// Mirror of backend/src/lib/nameValidation.ts. Customer + order names become
// SharePoint folder-path segments, so these characters are forbidden: '_' is
// the field separator in the folder template, the rest are illegal in
// SharePoint/OneDrive/Windows paths. Keep this list in sync with the backend —
// the server enforces the same rule and will 400 otherwise.
export const FORBIDDEN_NAME_CHARS = ['_', '\\', '/', ':', '*', '?', '"', '<', '>', '|', '#', '%'];

const FORBIDDEN_SET = new Set(FORBIDDEN_NAME_CHARS);

// Space-separated list for messages: _ \ / : * ? " < > | # %
export const FORBIDDEN_NAME_CHARS_DISPLAY = FORBIDDEN_NAME_CHARS.join(' ');

/** Error message if `name` contains a forbidden character, else null. */
export function folderNameError(name: string): string | null {
  const bad = [...new Set([...name].filter((ch) => FORBIDDEN_SET.has(ch)))];
  if (bad.length === 0) return null;
  return `The name can't contain ${bad.join(' ')} — it's used to build the SharePoint folder name. Not allowed: ${FORBIDDEN_NAME_CHARS_DISPLAY}`;
}
